// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__gb-dm"};